import {useContext, useSyncExternalStore} from 'react';
import BryntumContext from "../context/bryntumContext.jsx";

const useViews = () => { // assuming viewManager will be constructed on a board load will be available before this loads
  const { viewManager } = useContext(BryntumContext);
  const viewManagerState = useSyncExternalStore(
    viewManager ? viewManager.renderSubscribe.bind(viewManager): () => {},
    viewManager ? viewManager.renderSnapshot.bind(viewManager): () => {}
  )

  return viewManagerState;
};

export default useViews;